import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppState } from '@immosky/types';
import { select, Store } from '@ngrx/store';
import { selectIsMobileFilterOpen } from '@immosky/object-search-layout';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { SearchOverlayComponent } from '../components/filters/search-overlay/search-overlay.component';

@Injectable({
  providedIn: 'root',
})
export class SearchOverlayService {
  private isOpen$ = new BehaviorSubject<boolean>(false);
  private overlayRef!: OverlayRef | null;

  constructor(private store: Store<AppState>, private overlay: Overlay) {
    this.store
      .pipe(select(selectIsMobileFilterOpen))
      .subscribe((isMobileFilterOpen: boolean) => {
        if (isMobileFilterOpen) {
          this.close();
        }
      });
  }

  open() {
    this.isOpen$.next(true);
    this.createOverlay();
  }

  private createOverlay() {
    this.overlayRef = this.overlay.create({
      scrollStrategy: this.overlay.scrollStrategies.block(),
      hasBackdrop: false,
      disposeOnNavigation: true,
    });

    const portal = new ComponentPortal(SearchOverlayComponent);
    this.overlayRef.attach(portal);
  }

  close() {
    this.isOpen$.next(false);
    this.destroyOverlay();
  }

  private destroyOverlay() {
    this.overlayRef?.detach();
    this.overlayRef = null;
  }

  get isOpen(): Observable<boolean> {
    return this.isOpen$.asObservable();
  }
}
